var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleMapsLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m407 512h-302c-57.897 0-105-47.103-105-105v-302c0-57.897 47.103-105 105-105h302c57.897 0 105 47.103 105 105v302c0 57.897-47.103 105-105 105z",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m407 0h-151v512h151c57.897 0 105-47.103 105-105v-302c0-57.897-47.103-105-105-105z",
    fill: "#e5e5e5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m407 0h-277v148l356.429 327.6c15.925-18.414 25.571-42.401 25.571-68.6v-302c0-57.897-47.103-105-105-105z",
    fill: "#87e694"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m407 0h-151v263.809l230.429 211.791c15.925-18.414 25.571-42.401 25.571-68.6v-302c0-57.897-47.103-105-105-105z",
    fill: "#66cc70"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m0 105v302c0 57.897 47.103 105 105 105h30v-455h-123.369c-7.43 14.395-11.631 30.715-11.631 48z",
    fill: "#f9c0c0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m69.738 6.098c-29.577 10.577-53.063 34.063-63.64 63.64l436.164 436.164c29.576-10.577 53.062-34.063 63.64-63.64z",
    fill: "#ffdc40"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m256 192.361v127.279l186.262 186.262c29.576-10.577 53.062-34.063 63.64-63.64z",
    fill: "#ffab15"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m347 472c-68.925 0-125-56.075-125-125 0-25.508 7.648-50.058 22.118-70.998l12.504-18.096 21.729 3.417c2.849.45 5.759.677 8.649.677 13.551 0 26.569-4.973 36.656-14.002l23.344-20.897 23.344 20.896c10.087 9.03 23.105 14.003 36.656 14.003 2.89 0 5.8-.227 8.649-.675l21.729-3.418 12.504 18.096c14.47 20.939 22.118 45.489 22.118 70.997 0 68.925-56.075 125-125 125z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m449.883 276.002-12.504-18.096-21.729 3.418c-2.85.449-5.76.676-8.65.676-13.551 0-26.569-4.973-36.656-14.002l-23.344-20.897-23.344 20.896c-10.087 9.03-23.105 14.003-36.656 14.003-2.89 0-5.8-.227-8.649-.676l-21.729-3.417-.622.9v173.795c22.813 24.238 55.167 39.398 91 39.398 68.925 0 125-56.075 125-125 0-25.508-7.648-50.058-22.117-70.998z",
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m351 0c0 88.918 72.082 161 161 161v75c-130.339 0-236-105.661-236-236",
    fill: "#f2f2f2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m105 0c-5.093 0-10.099.372-15 1.076v509.848c4.901.704 9.907 1.076 15 1.076h75v-512z",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m120 0h30v246h-30z",
    fill: "#00aaf0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m135 391c-41.355 0-75-33.645-75-75s33.645-75 75-75 75 33.645 75 75-33.645 75-75 75z",
    fill: "#00c3ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m105 346 30-71 30 71-30-10z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m433.429 287.372-5.359-7.755-9.313 1.465c-3.873.609-7.829.918-11.757.918-18.48 0-36.235-6.783-49.996-19.101l-10.004-8.955-10.004 8.956c-13.761 12.317-31.516 19.1-49.996 19.1-3.928 0-7.884-.309-11.757-.918l-9.313-1.465-5.359 7.755c-12.149 17.582-18.571 38.201-18.571 59.628 0 57.897 47.103 105 105 105s105-47.103 105-105c0-21.427-6.422-42.046-18.571-59.628zm-86.429 134.628c-41.355 0-75-33.645-75-75 0-4.739.443-9.42 1.307-14h147.387c.864 4.58 1.307 9.261 1.307 14-.001 41.355-33.646 75-75.001 75z",
    fill: "#00c3ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m433.429 287.372-5.359-7.755-9.313 1.465c-3.873.609-7.829.918-11.757.918-18.48 0-36.235-6.783-49.996-19.101l-10.004-8.955-10.004 8.956c-13.761 12.317-31.516 19.1-49.996 19.1-3.928 0-7.884-.309-11.757-.918l-9.313-1.465-5.359 7.755c-1.63 2.359-3.149 4.777-4.571 7.241v104.726c18.159 31.45 52.148 52.661 91 52.661 57.897 0 105-47.103 105-105 0-21.427-6.422-42.046-18.571-59.628zm-86.429 134.628c-41.355 0-75-33.645-75-75 0-4.739.443-9.42 1.307-14h147.387c.864 4.58 1.307 9.261 1.307 14-.001 41.355-33.646 75-75.001 75z",
    fill: "#00aaf0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleMapsLogo);
export default __webpack_public_path__ + "static/media/apple_maps_logo.cfb8e9dd8f1348a8dc09c71ba6debcbf.svg";
export { ForwardRef as ReactComponent };